import { render } from "./AnalyticsView.vue?vue&type=template&id=23a27bfe&scoped=true"
import script from "./AnalyticsView.vue?vue&type=script&lang=js"
export * from "./AnalyticsView.vue?vue&type=script&lang=js"

import "./AnalyticsView.vue?vue&type=style&index=0&id=23a27bfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a27bfe"],['__file',"src/views/AnalyticsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23a27bfe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23a27bfe', __exports__)) {
    api.reload('23a27bfe', __exports__)
  }
  
  module.hot.accept("./AnalyticsView.vue?vue&type=template&id=23a27bfe&scoped=true", () => {
    api.rerender('23a27bfe', render)
  })

}


export default __exports__